import React, { useState, useEffect } from 'react';
import { Image as RImage, Dimensions } from 'react-native';
import { Image, Pressable, View } from 'modules/styled';
import { POST_IMAGE_W } from 'styles/layout';
import { useSelector, useDispatch } from 'react-redux';
import { goToPost, goToUrl } from 'modules/navigation/navigation.actions';
import { resizeImage } from 'utils/img';

const PREVIEW_WIDTH = POST_IMAGE_W * 8;

interface ImagePostInput {
  url: string;
  disabled: boolean;
  singlePost: boolean;
  preview: boolean;
  postUrl: string;
  _id: string;
}

export const ImagePost = ({
  url,
  disabled,
  singlePost,
  postUrl,
  preview,
  _id,
}: ImagePostInput): JSX.Element => {
  const dispatch = useDispatch();
  const screenSize = useSelector((state: any) => state.navigation.screenSize);

  const [dim, setDim] = useState({ width: 1, height: 1 });
  const [w, setW] = useState(0);

  useEffect(() => {
    RImage.getSize(url, (width, height) => {
      setDim({ width, height });
    });
  }, [url]);

  const wH = Dimensions.get('window')?.height || 0;
  const maxHeight = preview ? PREVIEW_WIDTH : wH * 0.6;
  const showFullSize = !preview && (singlePost || screenSize);

  const imageUri = showFullSize
    ? url
    : resizeImage(url, PREVIEW_WIDTH / 8, PREVIEW_WIDTH / 8);

  return (
    <View
      onLayout={(event) => {
        const { width } = event.nativeEvent.layout;
        setW(width);
      }}
      sx={{ flex: 1 }}
    >
      <Pressable
        external={singlePost}
        to={singlePost ? url : postUrl}
        nativeAction={() => {
          singlePost ? dispatch(goToUrl(url)) : dispatch(goToPost({ _id }));
        }}
        target={singlePost ? '_blank' : undefined}
        disabled={disabled}
      >
        <Image
          sx={{
            maxWidth: '100%',
            width: showFullSize ? '100%' : (PREVIEW_WIDTH * dim.width) / dim.height,
            height: showFullSize
              ? Math.min(maxHeight, (w * dim.height) / dim.width)
              : PREVIEW_WIDTH,
          }}
          resizeMode={'contain'}
          source={{ uri: imageUri }}
        />
      </Pressable>
    </View>
  );
};
